"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var Arrow = function Arrow(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "10",
    height: "10",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.15179 2.14355H8.31473C8.25781 2.14355 8.20424 2.17146 8.17076 2.21722L5 6.58775L1.82924 2.21722C1.79576 2.17146 1.74219 2.14355 1.68527 2.14355H0.848216C0.775671 2.14355 0.733261 2.22614 0.775671 2.2853L4.71094 7.71052C4.8538 7.90695 5.14621 7.90695 5.28795 7.71052L9.22322 2.2853C9.26674 2.22614 9.22433 2.14355 9.15179 2.14355Z",
    fill: "currentColor"
  }));
};

var _default = Arrow;
exports["default"] = _default;